import history from '../history';
import { scrollToEl } from './mini/scrollToAnchor';

function getElementByXpath(path) {
    return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}

function Navigator(options) {
    const page = options?.page;
    history.push(page);

    setTimeout(() => {
        let elemToScroll;

        if (options?.xPath) {
            elemToScroll = getElementByXpath(options?.xPath);
        } else if (options?.anchor) {
            elemToScroll = document.querySelector(`[data-anchor=${options?.anchor}]`);
        }
        scrollToEl(elemToScroll);
    }, 300);
}

window.alanPublicApi = {
    ...(window.alanPublicApi ? window.alanPublicApi : {}),
    navigate: Navigator
};



export default Navigator;